import { roleHasPermission } from "@crewledger/shared/auth";
import { useAuth } from "@/features/auth/auth-provider";

export function useBillingPermissions() {
  const { user } = useAuth();
  const role = (user?.role ?? "EMPLOYEE") as Parameters<typeof roleHasPermission>[0];

  return {
    canRead: roleHasPermission(role, "company:billing:read"),
    canWrite: roleHasPermission(role, "company:billing:write"),
    isReadOnly: roleHasPermission(role, "company:billing:read") && !roleHasPermission(role, "company:billing:write"),
    role,
  };
}
